import { Property } from '../../types/property';

export const showBroadbandChecker = (property: Property) => {
  return (
    !property.broadbandSpeed &&
    !property.featuredDevelopmentContent &&
    property.country?.isoCode3 === 'NIR' &&
    property.propertyType?.key === 'residential'
  );
};

export const showBroadbandInterest = (property: Property) => {
  return (
    property.broadbandSpeed &&
    !property.broadbandSpeed.fibrusAvailable &&
    !property.featuredDevelopmentContent &&
    property.country?.isoCode3 === 'NIR' &&
    property.propertyType?.key === 'residential'
  );
};

export default showBroadbandChecker;
